import { render, staticRenderFns } from "./ActaReunionCC.vue?vue&type=template&id=a8806b14&scoped=true"
import script from "./ActaReunionCC.vue?vue&type=script&lang=js"
export * from "./ActaReunionCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8806b14",
  null
  
)

export default component.exports